import Mousetrap from 'mousetrap'

import { LeftDrawerContent, RightDrawerContent } from '@app/shared/types/drawer'
import { useDrawer } from '@app/shared/pinia/drawer'
import getPiniaInstance from '@app/shared/pinia/instance'

const BELGIUM_FRANCE_COUNTRIES = ['BE', 'FR']

export function isInputFocused(): boolean {
  let activeElement = document.activeElement
  while (activeElement?.shadowRoot?.activeElement) {
    activeElement = activeElement.shadowRoot.activeElement
  }
  if (!activeElement) return false

  const tagName = activeElement.tagName.toLowerCase()
  if (tagName === 'input' || tagName === 'textarea' || tagName === 'select') {
    return true
  }

  return (activeElement as HTMLElement).isContentEditable === true
}

function isBelgiumOrFrance(): boolean {
  const country = window.Silverfin?.currentFirmCountry
  return BELGIUM_FRANCE_COUNTRIES.includes(country)
}

function isDenmark(): boolean {
  return window.Silverfin?.currentFirmCountry === 'DK'
}

export function getLeftDrawerHotkey(): string {
  if (isDenmark()) return ','
  return isBelgiumOrFrance() ? ',' : '['
}

export function getRightDrawerHotkey(): string {
  if (isDenmark()) return '.'
  return isBelgiumOrFrance() ? ';' : ']'
}

export function getHotkeyKbd(hotkey: string): string {
  return `<kbd class='tw-ml-1 tw-outline tw-outline-1 tw-outline-sf-neutral-light-2 tw-rounded-md tw-px-[6px] tw-py-[2px] tw-text-sm'>${hotkey}</kbd>`
}

export default (): (() => void) => {
  const leftHotkey = getLeftDrawerHotkey()
  const rightHotkey = getRightDrawerHotkey()
  const drawerStore = useDrawer(getPiniaInstance())

  Mousetrap.bind(leftHotkey, () => {
    if (isInputFocused()) return true

    drawerStore.toggleDrawer({
      direction: 'left',
      content: LeftDrawerContent.Default,
    })
    return false
  })

  Mousetrap.bind(rightHotkey, () => {
    if (isInputFocused()) return true

    if (drawerStore.isRightDrawerOpen) {
      drawerStore.closeRightDrawer()
    } else {
      drawerStore.openRightDrawer(RightDrawerContent.Communication)
    }
    return false
  })

  return () => {
    Mousetrap.unbind(leftHotkey)
    Mousetrap.unbind(rightHotkey)
  }
}
